var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard33(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_33);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #656fb2;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.25px;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Ellipse_34);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_34",
    x: -0.843,
    y: 2.314,
    width: 46.686,
    height: 46.686,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_33",
    "data-name": "Artboard \\u2013 33",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(-10585.983 -6568.615)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 10585.98, 6568.62)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34",
    className: "cls-2",
    cx: 14.343,
    cy: 14.343,
    r: 14.343,
    transform: "translate(8.16 8.31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(10603.104 6585.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-3",
    d: "M9.589,12.737V11.616A2.241,2.241,0,0,0,7.348,9.375H2.866A2.241,2.241,0,0,0,.625,11.616v1.121",
    transform: "translate(-0.625 -2.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-3",
    d: "M7.607,4.116A2.241,2.241,0,1,1,5.366,1.875,2.241,2.241,0,0,1,7.607,4.116Z",
    transform: "translate(-0.884 -1.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-3",
    d: "M14.181,12.745V11.624A2.241,2.241,0,0,0,12.5,9.456",
    transform: "translate(-1.855 -2.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-3",
    d: "M10,1.956A2.241,2.241,0,0,1,10,6.3",
    transform: "translate(-1.596 -1.883)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard33);
export default __webpack_public_path__ + "static/media/Artboard – 33.74b746c2ed16130b37acf160d9e2f082.svg";
export { ForwardRef as ReactComponent };